<template>
  <div class="allExams">
    <div class="exam-card" v-for="(item, index) in examinationRecordArray" :key="item.id || index">
      <div class="card-content">
        <!-- 左侧编号 -->
        <div class="card-index">
          <span class="index-num">{{ (index + 1).toString().padStart(2, '0') }}</span>
        </div>
        
        <!-- 主信息区 -->
        <div class="card-main">
          <div class="paper-header">
            <h3 class="paper-name" :title="item.paperName.length > 20 ? item.paperName : ''">{{ item.paperName }}</h3>
            <span class="status-tag">
              <i class="el-icon-success"></i> 已审批
            </span>
          </div>
          <div class="paper-meta">
            <span class="meta-item">
              <i class="el-icon-time"></i>
              {{ item.createTime }}
            </span>
            <span class="meta-item">
              <i class="el-icon-tickets"></i>
              常规试卷
            </span>
            <span class="meta-item">
              <i class="el-icon-monitor"></i>
              {{ getLangName(item.langCode) }}
            </span>
          </div>
        </div>
        
        <!-- 统计数据 -->
        <div class="card-stats">
          <div class="stat-item">
            <span class="stat-value">{{ item.questionCount }}</span>
            <span class="stat-label">总题数</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-value">{{ item.questionCorrect }}</span>
            <span class="stat-label">正确数</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-value">
              {{ item.doTime }}<span class="unit">分钟</span>
            </span>
            <span class="stat-label">用时</span>
          </div>
        </div>
        
        <!-- 得分圆环 -->
        <div class="card-score">
          <div class="score-ring" :class="getScoreClass(item)">
            <span class="score-num">{{ item.userScore }}</span>
            <span class="score-total">/{{ item.paperScore }}</span>
          </div>
          <span class="score-label">最终得分</span>
        </div>
        
        <!-- 操作按钮 -->
        <div class="card-actions">
          <button class="action-btn snapshot-btn" @click="showAnswerDetails(item)">
            <i class="el-icon-camera-solid"></i>
            成绩快照
          </button>
          <button class="action-btn analysis-btn" @click="viewPaper(item)">
            <i class="el-icon-view"></i>
            答案解析
          </button>
        </div>
      </div>
    </div>
    <answer2 v-if="showAnswer" is-show="showAnswer" :scoreDetail="answerInfo" @close="handleClose"></answer2>
  </div>
</template>

<script>
import answer2 from "@/components/answer2.vue";
import {examinationRecord} from "@/api/index.js"

export default {
  components: {
    answer2
  },
  props: {
    examinationRecordArray: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showAnswer: false,
      answerInfo: {},
    }
  },
  methods: {
    getLangName(langCode) {
      const langMap = {
        'ROBOT': '机器人技术',
        'Scratch': 'Scratch',
        'Pyhton': 'Python',
        'Python': 'Python',
        'NOI': 'C/C++',
        'NOIP': 'C/C++',
        'CSP-J': 'C/C++',
        'CSP-S': 'C/C++',
        'C': 'C/C++'
      };
      return langMap[langCode] || '其它';
    },
    getScoreClass(item) {
      const ratio = item.userScore / item.paperScore;
      if (ratio >= 0.8) return 'score-excellent';
      if (ratio >= 0.6) return 'score-good';
      return 'score-need-improve';
    },
    viewPaper(item) {
      let jumpRouter = this.$router.resolve({
        path: "/viewTestPaper?id=" + item.id
      })
      window.open(jumpRouter.href, '_blank');
    },
    toOnlineClass(item) {
      this.$router.push({
        path: "/courseSelectionCenter"
      })
    },
    showAnswerDetails(item) {
      console.log(item)
      this.answerInfo = item;
      this.showAnswer = true;
    },
    handleClose() {
      this.showAnswer = false;
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.allExams {
  width: 100%;
  margin-top: 16px;
}

// 考试卡片
.exam-card {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 16px;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border-color: #e8e8e8;
  }
}

.card-content {
  display: flex;
  align-items: center;
  padding: 24px 28px;
  gap: 28px;
}

// 左侧序号
.card-index {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border: 2px solid #e8def8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  
  .index-num {
    font-size: 20px;
    font-weight: 600;
    color: #7c3aed;
  }
}

// 主信息区
.card-main {
  flex: 1;
  min-width: 0;
  
  .paper-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
  }
  
  .paper-name {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    width: 340px;
    flex-shrink: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .status-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 10px;
    background: #f0fdf4;
    border-radius: 20px;
    font-size: 12px;
    color: #22c55e;
    white-space: nowrap;
    flex-shrink: 0;
    
    i {
      font-size: 12px;
    }
  }
  
  .paper-meta {
    display: flex;
    align-items: center;
    gap: 24px;
    
    .meta-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      color: #9ca3af;
      
      i {
        font-size: 14px;
        color: #d1d5db;
      }
    }
  }
}

// 统计区域
.card-stats {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 0 24px;
  
  .stat-item {
    text-align: center;
    display: flex;
    flex-direction: column-reverse;
    
    .stat-value {
      font-size: 28px;
      font-weight: 700;
      color: #374151;
      line-height: 1.2;
      
      .unit {
        font-size: 14px;
        font-weight: 400;
        color: #9ca3af;
        margin-left: 2px;
      }
    }
    
    .stat-label {
      font-size: 12px;
      color: #9ca3af;
      margin-bottom: 4px;
    }
  }
  
  .stat-divider {
    width: 1px;
    height: 40px;
    background: #f3f4f6;
  }
}

// 得分圆环
.card-score {
  text-align: center;
  padding: 0 16px;
  
  .score-ring {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto 8px;
    
    &.score-excellent {
      background: linear-gradient(135deg, #22c55e 0%, #4ade80 100%);
    }
    
    &.score-good {
      background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
    }
    
    &.score-need-improve {
      background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
    }
    
    .score-num {
      font-size: 24px;
      font-weight: 700;
      color: #fff;
      line-height: 1;
    }
    
    .score-total {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.85);
      margin-top: 2px;
    }
  }
  
  .score-label {
    font-size: 12px;
    color: #9ca3af;
  }
}

// 操作按钮
.card-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  
  .action-btn {
    min-width: 100px;
    padding: 10px 18px;
    border-radius: 20px;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.25s ease;
    
    i {
      font-size: 14px;
    }
  }
  
  .snapshot-btn {
    background: #fff;
    border: 1px solid #22c55e;
    color: #22c55e;
    
    &:hover {
      background: #22c55e;
      color: #fff;
    }
  }
  
  .analysis-btn {
    background: #fff;
    border: 1px solid #7c3aed;
    color: #7c3aed;
    
    &:hover {
      background: #7c3aed;
      color: #fff;
    }
  }
}

</style>
